import { UseCase } from '@cp/shared/usecase';
import { IRouter } from '@cp/shared/router';
import { ClientPageResolver } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import { SerializedError } from '@reduxjs/toolkit';
import { ApiServerError } from '@cp/utils/rtk/query/model';
import { ClientProfileViewModel } from '@common/model/client';
import { RequestFn } from '../api';
import { UseCaseRequest } from './useCase.request';

export class RespondToVacancyUseCase implements UseCase<UseCaseRequest, boolean | ApiServerError | SerializedError> {
  constructor(
    private readonly requestFn: RequestFn,
    private readonly onNeedLogin: () => void,
    private readonly patronage: { check: (client: ClientProfileViewModel) => Promise<boolean>; action: () => void },
    private readonly router: IRouter,
    private readonly resolver: ClientPageResolver,
  ) {}

  async execute(req: UseCaseRequest) {
    if (!req.responder) {
      this.onNeedLogin();
      return false;
    }
    if (!req.responder?.type || clientTypeToSuitableCatalogItemType(req.responder.type) !== req.catalogItem.type) {
      return false;
    }
    // patronage
    if (!(req.responder.mainResumeIsPublished || (await this.patronage.check(req.responder)))) {
      this.patronage.action();
      return false;
    }
    const response = await this.requestFn({ id: req.catalogItem.id });
    if ('error' in response) {
      return response.error;
    }
    await this.router.navigate(this.resolver.resolve({ page: ClientWebPage.ProfileMessages, queryParams: response.data }));
    return true;
  }
}
